import {
  createActionTypes,
  createAsyncAction,
  createAsyncActionTypes,
} from "@dpdgroupuk/redux-action-creator";

import { apisClient } from "../../apis";
import { getAppRoles } from "../auth/selectors";

const PLTRACKIT_ROLE = "pltrackit";
const TRACKING_ACCESS_DENIED_MESSAGE =
  "Sorry, we have not provided you with access to this part of the website.\n" +
  "\n" +
  "Please contact customer services to enquire about having this added to your account";

export const UmsActionTypes = createActionTypes("ums", {
  FETCH_CUSTOMER: createAsyncActionTypes("FETCH_CUSTOMER"),
  FETCH_CUSTOMERS: createAsyncActionTypes("FETCH_CUSTOMERS"),
});

export const fetchCustomer = createAsyncAction(
  () => apisClient.ums.fetchCustomer(),
  UmsActionTypes.FETCH_CUSTOMER
);

export const fetchCustomers = createAsyncAction(
  () => apisClient.ums.fetchCustomers(),
  UmsActionTypes.FETCH_CUSTOMERS
);

export const fetchInitialUmsData = () => dispatch =>
  Promise.all([dispatch(fetchCustomer()), dispatch(fetchCustomers())]);

// Runs after ums shell data so Access Denied can render under the navbar
export const verifyTrackingAccess = () => (_, getState) => {
  const appRoles = getAppRoles(getState()) || [];
  if (!appRoles.includes(PLTRACKIT_ROLE)) {
    return Promise.reject({
      statusCode: 403,
      errors: [{ message: TRACKING_ACCESS_DENIED_MESSAGE }],
    });
  }
  return Promise.resolve();
};
